export const firebaseConfig = {
    apiKey: "AIzaSyA0DQ7ROC6Ka4-7hiJe237dwKjUKd8-vdg",
    authDomain: "cryptocrunch-bb4a5.firebaseapp.com",
    projectId: "cryptocrunch-bb4a5",
    storageBucket: "cryptocrunch-bb4a5.appspot.com",
    messagingSenderId: "119612118490",
    appId: "1:119612118490:web:3b4bb0f040d5198c0edce3"
  };